module.exports = __webpack_public_path__ + "static/media/BMW G310R.f9dbd890.png";